import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeTWRatingCreate,
  detail: routeTWRatingDetail,
  home: routeRatingSettingsHome,
  root: routeRatingSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-rating',
  createPath: 'new-rating',
  detailName: 'ratingDetail',
  doctype: DOCTYPES.TW_RATING,
  homeName: 'rating',
  path: 'rating',
  views: {
    create: async () => await import('@/components/viewsExternal/twRating/AddTWRating.vue'),
    detail: async () => await import('@/components/viewsExternal/twRating/ViewTWRating.vue'),
    list: async () => await import('@/components/viewsExternal/settings/brm/ViewBRMSettings.vue'),
  },
})

export {
  routeRatingSettingsHome,
  routeRatingSettingsRoot,
  routeTWRatingCreate,
  routeTWRatingDetail,
}
